import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=2145e70a"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=2145e70a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports